import { profileSchema } from '../registration-wizard/profile';
import { signupCredentialsSchema } from '../registration-wizard/credentials';


/** Регистрация по приглашению: только профиль и учётные данные, без компании и биллинга. */
export const teamRegistrationSchema = signupCredentialsSchema.extend(profileSchema.shape);

export type TeamRegistrationFormData = ReturnType<typeof teamRegistrationSchema.parse>;
